module.exports = __webpack_public_path__ + "img/463.ee12811c.jpg";